import thermostatventilImg from './assets/thermostatventil-img.jpeg';
import raumthermostatImg from './assets/raumthermostat-img.jpeg';
import kombiImg from './assets/kombi-img.png';
import manuellImg from './assets/manuell-img.jpeg';
import resultIllus1 from './assets/result-iIllus-1.png';
import resultIllus2 from './assets/result-iIllus-2.png';
import resultIllus3 from './assets/result-iIllus-3.png';
import resultIllus4 from './assets/result-iIllus-4.png';
import resultIllus5 from './assets/result-iIllus-5.png';
import tachoGreen from './assets/tacho-green.svg';
import tachoLightGreen from './assets/tacho-light-green.svg';
import tachoOrange from './assets/tacho-orange.svg';
import tachoRed from './assets/tacho-red.svg';
import tachoYellow from './assets/tacho-yellow.svg';
import React from 'react';

const questions = [
  {
    title: 'Welche Art von Wohnung oder Haus bewohnen Sie?',
    name: 'houseType',
    id: 1,
    progressbarArea: 1,
    options: [
      {
        text: 'Einfamilienhaus',
        param: 1,
        points: 0,
      },
      {
        text: 'Reihenhaus (Rand/Doppelhaushälfte)',
        param: 2,
        points: 0,
      },
      {
        text: 'Reihenhaus (Mitte/Nachbarn an beiden Seiten)',
        param: 3,
        points: 0,
      },
      {
        text: 'Wohnung',
        param: 4,
        points: 0,
      },
    ],
  },
  {
    title: 'Wie groß ist Ihre beheizte Fläche?',
    subtitle:
      'Vergessen Sie dabei nicht ggf. beheizte Nutzflächen wie Keller zusätzlich zur Wohnfläche dazu zu rechnen.',
    name: 'area',
    id: 2,
    progressbarArea: 1,
    options: [
      {
        text: (
          <span>
            bis 49 m<sup>2</sup>
          </span>
        ),
        param: 1,
        points: 0,
      },
      {
        text: (
          <span>
            50-74 m<sup>2</sup>
          </span>
        ),
        param: 2,
        points: 0,
      },
      {
        text: (
          <span>
            75-99 m<sup>2</sup>
          </span>
        ),
        param: 3,
        points: 0,
      },
      {
        text: (
          <span>
            100-149 m<sup>2</sup>
          </span>
        ),
        param: 4,
        points: 0,
      },
      {
        text: (
          <span>
            150+ m<sup>2</sup>
          </span>
        ),
        param: 5,
        points: 0,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers => [2, 3, 4, 5].includes(answers[1]?.param), // Frage 2: nicht unter 49m2
        title: 'Türe zu unbenutzten Räumen schließen',
        text: 'Ungenützte Räume, Keller und Flure müssen nicht mehr als 18°C geheizt werden. So vermeiden Sie Schimmelbildung und sparen Heizkosten. Allerdings ist es wichtig, dass die Türe zu diesen Räumlichkeiten geschlossen bleibt. Sonst kühlen die Zimmer, die mehr geheizt werden, aus. Das passiert weil die warme Luft in die kühleren Räume zieht.',
      },
    ],
  },
  {
    title: 'Welcher Dämmstandard trifft auf Ihr Wohnhaus zu?',
    name: 'insulation',
    id: 3,
    progressbarArea: 1,
    options: [
      {
        text: 'Altbau, ungedämmt',
        param: 1,
        points: 35,
      },
      {
        text: 'Neubau/Altbau, gedämmt vor dem Jahr 2000',
        param: 2,
        points: 25,
      },
      {
        text: 'Neubau/Altbau, gedämmt nach dem Jahr 2000',
        param: 3,
        points: 15,
      },
      {
        text: 'Niedrig(st)energiehaus',
        param: 4,
        points: 5,
      },
      {
        text: 'Passivhaus',
        param: 5,
        points: 0,
      },
      {
        text: 'Nicht bekannt',
        param: 6,
        points: 35,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers =>
          [1, 2, 3].includes(answers[2]?.param) && answers[4]?.param === 1, // Frage 3: Altbau, ungedämmt, Mieter*in
        title: 'Sanierungswunsch äußern',
        text: 'Wenden Sie sich an den/die Gebäudeeigentümer*in bzw. Hausverwaltung, um sich über geplante Sanierungsarbeiten der Dämmung oder Fenster zu informieren. Förderungen unterstützen diese Vorhaben für Eigentümer*innen, und Sie könnten somit effizienter heizen.',
        links: [
          {
            link: 'https://www.umweltfoerderung.at/privatpersonen',
            linkText: 'Mehr zu Förderungen',
          },
        ],
      },
      {
        id: 2,
        icon: 'lightbulb-on',
        condition: answers =>
          [1, 2, 3].includes(answers[2]?.param) && answers[4]?.param === 2, // Frage 3: Altbau, ungedämmt, Eigentümer*in
        title: 'Sanierung in Erwägung ziehen',
        text: 'Förderungen unterstützen Sanierungen von Dämmung und Fenstern, und Sie könnten somit effizienter heizen. Finden Sie heraus, welche Sanierung bei Ihnen den größten Hebel hat und welche Förderungen für Sie in Frage kommen.',
        links: [
          {
            link: 'https://www.umweltfoerderung.at/privatpersonen',
            linkText: 'Mehr zu Förderungen',
          },
          {
            link: 'https://www.wienenergie.at/privat/produkte/energieberatung/',
            linkText: 'Mehr zum Thema Energieberatung',
          },
        ],
      },
      {
        id: 3,
        icon: 'circle-check',
        condition: answers => answers[2]?.param === 4,
        title: 'Niedrig(st)energiehaus gut gewählt',
        text: 'Mit einem Niedrig(st)energiehaus sind Sie bereits auf dem besten Weg zur Heizungseffizienz. Nur Passivhäuser bieten noch höhere Effizienz beim Heizen.',
      },
      {
        id: 4,
        icon: 'circle-check',
        condition: answers => answers[2]?.param === 5,
        title: 'Passivhaus richtig gewählt',
        text: 'Mit einem Passivhaus sparen Sie  Heizenergie und damit verbundene Kosten.',
      },
      {
        id: 5,
        icon: 'lightbulb-on',
        condition: answers => answers[2]?.param === 6,
        title: 'Über Dämmung informieren',
        text: 'Ob und wie das Gebäude gedämmt ist, hat einen besonders großen Einfluss auf Heizungseffizienz. Um Ihre Heizungseffizienz zu optimieren, informieren Sie sich über Ihre Dämmung.',
      },
    ],
  },
  {
    title: 'Wie ist die Dichtung Ihrer Fenster und Türen?',
    name: 'sealing',
    instructions:
      'Wie können Sie testen, ob Ihre Fenster intakt sind? Einfach ein Blatt Papier zwischen Fensterflügel und Fensterstock klemmen und versuchen, es bei geschlossenem Fenster herauszuziehen. Bleibt das Papier stecken, besteht kein Handlungsbedarf. Lässt es sich aber herausziehen, dann dichten die Fenster nicht mehr richtig ab.',
    id: 4,
    progressbarArea: 1,
    options: [
      {
        param: 1,
        text: 'Dicht',
        points: 0,
      },
      {
        param: 2,
        text: 'Teilweise dicht/undicht',
        points: 3,
      },
      {
        param: 3,
        text: 'Undicht',
        points: 5,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'circle-check',
        condition: answers => answers[3]?.param === 1, // Frage 4: Dicht
        title: 'Dichte Fenster und Türen',
        text: 'Gehen Sie auf Nummer Sicher und überprüfen Sie die Dichtheit. Einfach ein Blatt Papier zwischen Fensterflügel und Fensterstock klemmen und versuchen, es bei geschlossenem Fenster herauszuziehen. Bleibt das Papier stecken, besteht kein Handlungsbedarf. Lässt es sich aber herausziehen, dann dichten die Fenster nicht mehr richtig ab.',
      },
      {
        id: 2,
        icon: 'lightbulb-on',
        condition: answers => [2, 3].includes(answers[3]?.param), // Frage 4: Teilweise dicht/undicht, Undicht
        title: 'Fenster und Türen abdichten',
        text: 'Dichte Fenster und Türen mit Wärmeschutz halten die Wärme im Raum und drücken den Energieverbrauch der Heizung deutlich. Mit aufklebbaren Isolierbändern lässt sich leicht Abhilfe schaffen. Absolut dichte Fenster können eine Kostenersparnis von bis zu 30 % bringen.',
      },
    ],
  },
  {
    title: 'Sind Sie Mieter*in oder Eigentümer*in?',
    subtitle:
      'Diese Frage hat keinen Einfluss auf Ihr Heizverhalten, hilft uns aber Ihnen relevante Empfehlungen zu geben.',
    name: 'ownership',
    id: 5,
    progressbarArea: 1,
    options: [
      {
        param: 1,
        text: 'Mieter*in',
        points: 0,
      },
      {
        param: 2,
        text: 'Eigentümer*in',
        points: 0,
      },
    ],
  },
  {
    title: 'Womit heizen Sie Ihre Wohnung bzw. Ihr Haus?',
    subtitle:
      'Falls Sie sich nicht sicher sind, finden Sie die Info eventuell in Ihren Unterlagen (Kauf- oder Mietvertrag, Rechnungen). Sie können auch Ihre*n Vermieter*in oder die Hausverwaltung fragen.',
    name: 'deviceType',
    id: 6,
    progressbarArea: 2,
    options: [
      {
        param: 1,
        text: 'Biomasse',
        points: 0,
      },
      {
        param: 2,
        text: 'Elektrische Direktheizung',
        points: 30,
      },
      {
        param: 3,
        text: 'Erdgas',
        points: 30,
      },
      {
        param: 4,
        text: 'Erdöl',
        points: 30,
      },
      {
        param: 5,
        text: 'Fernwärme',
        points: 0,
      },
      {
        param: 6,
        text: 'Wärmepumpe',
        points: 0,
      },
      {
        param: 7,
        text: 'Festbrennstoff (wie z.B. Kohle)',
        points: 30,
      },
      {
        param: 8,
        text: 'Nicht bekannt',
        points: 30,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'circle-check',
        condition: answers => answers[5]?.param === 1, // Frage 6: Biomasse
        title: 'Optimale Heizungsart',
        text: 'Mit Biomasse haben Sie bereits eine der umweltschonendsten Heizungsarten.',
      },
      {
        id: 2,
        icon: 'circle-check',
        condition: answers => answers[5]?.param === 5, // Frage 6: Fernwärme
        title: 'Optimale Heizungsart',
        text: 'Mit Fernwärme haben Sie bereits eine der umweltschonendsten Heizungsarten gewählt.',
      },
      {
        id: 3,
        icon: 'circle-check',
        condition: answers => answers[5]?.param === 6, // Frage 6: Wärmepumpe
        title: 'Optimale Heizungsart',
        text: 'Mit einer Wärmepumpe haben Sie bereits eine der umweltschonendsten Heizungsarten gewählt.',
      },
      {
        id: 4,
        icon: 'lightbulb-on',
        condition: answers => answers[5]?.param === 6, // Frage 6: Wärmepumpe
        title: 'Wärmepumpevorlaufzeit optimieren',
        text: 'Ein wichtiger Faktor für die Effizienz einer Wärmepumpe ist die richtige Vorlauftemperatur. Lesen Sie nach, was das genau bedeutet und wie Sie die optimale Vorlauftemperatur einstellen können.',
        links: [
          {
            link: 'https://www.wienenergie.at/blog/optimale-vorlauftemperatur-waermepumpe/',
            linkText: 'Mehr zu optimaler Vorlauftemperatur',
          },
        ],
      },
      {
        id: 5,
        icon: 'lightbulb-on',
        condition: answers =>
          answers[0]?.param === 4 && // Frage 1: Wohnung
          answers[4]?.param === 2 && // Frage 5: Eigentümer*in
          [2, 3, 4, 7].includes(answers[5]?.param), // Frage 6: Elektr. Direktheizung, Erdgas, Erdöl, Festbrennstoff
        title: 'Fernwärmeverfügbarkeit abfragen',
        text: 'Fernwärme ermöglicht effizientes Heizen ohne fossile Energieformen. Informieren Sie sich zur Verfügbarkeit der Fernwärme in ihrem Gebiet.',
        links: [
          {
            link: 'https://www.wienenergie.at/rausausgas/',
            linkText: 'Verfügbarkeit von Fernwärme',
          },
          {
            link: 'https://www.wienenergie.at/blog/was-ist-fernwaerme/',
            linkText: 'Mehr zum Thema Fernwärme',
          },
        ],
      },
      {
        id: 6,
        icon: 'lightbulb-on',
        condition: answers =>
          answers[0]?.param !== 4 && // Frage 1: nicht Wohnung
          answers[4]?.param === 2 && // Frage 5: Eigentümer*in
          [2, 3, 4, 7].includes(answers[5]?.param), // Frage 6: Elektr Direktheizung, Erdgas, Erdöl, Festbrennstoff
        title: 'Auf Wärmepumpe umsteigen',
        text: 'Wärmepumpen ermöglichen effizientes Heizen ohne fossile Energieformen. Erfahren Sie mehr zum Thema:',
        links: [
          {
            link: 'https://www.wienenergie.at/blog/arten-und-vorteile-von-waermepumpen/',
            linkText: 'Arten von Wärmepumpen',
          },
          {
            link: 'https://www.wienenergie.at/blog/die-waermepumpe-heizt-so-wie-dein-kuehlschrank-kuehlt-nur-umgekehrt/',
            linkText: 'Wie funktioniert eine Wärmepumpe?',
          },
          {
            link: 'https://www.wienenergie.at/blog/gibt-es-foerderungen-fuer-waermepumpen/',
            linkText: 'Mehr zum Thema Förderungen',
          },
        ],
      },
      {
        id: 7,
        icon: 'lightbulb-on',
        condition: answers =>
          answers[4]?.param === 1 && // Frage 5: Mieter*in
          [2, 3, 4, 7].includes(answers[5]?.param), // Frage 6: Elektr Direktheizung, Erdgas, Erdöl, Festbrennstoff
        title: 'Hausverwaltung/Vermieter*in kontaktieren',
        text: 'Fernwärme ermöglicht effizientes Heizen ohne fossile Energieformen. Informieren Sie sich zur Verfügbarkeit der Fernwärme in Ihrem Gebiet und suchen Sie einfach ein Gespräch mit Ihrer Hausverwaltung/Vermieter*in.',
        links: [
          {
            link: 'https://www.wienenergie.at/rausausgas/',
            linkText: 'Verfügbarkeit der Fernwärme',
          },
        ],
      },
      {
        id: 8,
        icon: 'lightbulb-on',
        condition: answers => answers[5]?.param === 8, // Frage 6: Nicht bekannt
        title: 'Über Heizung informieren',
        text: 'Die Art der Heizung hat einen besonders großen Einfluss auf Heizungseffizienz. Um Ihre Heizungseffizienz zu optimieren, informieren Sie sich über Ihre Heizung.',
      },
    ],
  },
  {
    title: 'Wie heizen Sie?',
    name: 'releaseType',
    id: 7,
    progressbarArea: 2,
    options: [
      {
        param: 1,
        text: 'Belüftungssystem',
        points: 5,
      },
      {
        param: 2,
        text: 'Deckenheizung',
        points: 0,
      },
      {
        param: 3,
        text: 'Fussbodenheizung',
        points: 0,
      },
      {
        param: 4,
        text: 'Heizkörper',
        points: 3,
      },
      {
        param: 5,
        text: 'Unterflurheizung',
        points: 5,
      },
      {
        param: 6,
        text: 'Wandheizung',
        points: 0,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers => answers[6]?.param === 1, // Frage 7: Belüftungssystem
        title: 'Belüftungssystem reinigen und Raum geben',
        text: 'Vermeiden Sie es, Möbel oder Vorhänge direkt vor das Belüftungssystem zu stellen und entfernen Sie Staub und Schmutz von den Ausgängen. Dadurch kann die warme Luft optimal im Raum zirkulieren und Sie heizen effizienter.',
      },
      {
        id: 2,
        icon: 'lightbulb-on',
        condition: answers => answers[6]?.param === 1, // Frage 7: Belüftungssystem
        title: 'Luftfeuchtigkeit im Blick behalten',
        text: 'Heizen mit Belüftungssystemen kann trockene Luft verursachen. Pflanzen, Wäsche in der Wohnung trocknen oder Badezimmertüren nach dem Duschen offen lassen, fördert die Luftfeuchtigkeit.',
      },
      {
        id: 3,
        icon: 'circle-check',
        condition: answers => answers[6]?.param === 2, // Frage 7: Deckenheizung
        title: 'Optimale Wärmeabgabe',
        text: 'Mit einer Deckenheizung haben Sie bereits eine der erffizientesten Heizarten.',
      },
      {
        id: 4,
        icon: 'circle-check',
        condition: answers => answers[6]?.param === 3, // Frage 7: Fussbodenheizung
        title: 'Optimale Wärmeabgabe',
        text: 'Mit einer Fussbodenheizung haben Sie bereits eine der effizientesten Heizungsarten.',
      },
      {
        id: 5,
        icon: 'lightbulb-on',
        condition: answers => answers[6]?.param === 4, // Frage 7: Heizkörper
        title: 'Heizkörper reinigen und Raum geben',
        text: 'Vermeiden Sie es, Möbel oder Vorhänge direkt vor die Heizkörper zu stellen und entfernen Sie Staub und Schmutz. Dadurch kann die warme Luft optimal im Raum zirkulieren und Sie heizen effizienter.',
      },
      {
        id: 6,
        icon: 'lightbulb-on',
        condition: answers => answers[6]?.param === 4, // Frage 7: Heizkörper
        title: 'Heizkörper entlüften',
        text: 'Es ist wichtig, dass Heizkörper in regelmäßigen Abständen entlüftet werden, vor allem wenn diese nicht mehr ganz warm werden oder beginnen zu gluckern. Im Idealfall werden Heizungen einmal im Jahr, bevor die Heizperiode beginnt, entlüftet.',
      },
      {
        id: 7,
        icon: 'lightbulb-on',
        condition: answers => answers[6]?.param === 5, // Frage 7: Unterflurheizung
        title: 'Unterflurheizung reinigen und Raum geben',
        text: 'Vermeiden Sie es, Möbel oder Vorhänge direkt vor die Unterflurheizung zu stellen und entfernen Sie Staub und Schmutz von den Ausgängen. Dadurch kann die warme Luft optimal im Raum zirkulieren und Sie heizen effizienter.',
      },
      {
        id: 8,
        icon: 'lightbulb-on',
        condition: answers => answers[6]?.param === 5, // Frage 7: Unterflurheizung
        title: 'Luftfeuchtigkeit in Blick behalten',
        text: 'Heizen mit Unterflurheizungen kann trockene Luft verursachen. Pflanzen, Wäsche in der Wohnung trocknen oder Badezimmertüren nach dem Duschen offen lassen, fördert die Luftfeuchtigkeit.',
      },
      {
        id: 9,
        icon: 'circle-check',
        condition: answers => answers[6]?.param === 6, // Frage 7: Wandheizung
        title: 'Optimale Wärmeabgabe',
        text: 'Mit einer Wandheizung haben Sie bereits eine der effizientesten Heizungsarten.',
      },
    ],
  },
  {
    title: 'Wie alt ist Ihr Heizgerät?',
    name: 'deviceAge',
    id: 8,
    progressbarArea: 2,
    options: [
      {
        param: 1,
        text: 'Bis 15 Jahre alt',
        points: 0,
      },
      {
        param: 2,
        text: 'Über 15 Jahre alt',
        points: 5,
      },
      {
        param: 3,
        text: 'Nicht bekannt',
        points: 5,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers =>
          answers[7]?.param === 2 && answers[4]?.param === 2, // Frage 8: Über 15 Jahre alt und Eigentümer*in
        title: 'Auf klimafreundliche Anlage umsteigen',
        text: 'Der Tausch von ineffizienten Heizungssystemen, die mindestens 15 Jahre alt sind, gegen klimafreundliche Anlagen wird aktiv mit Förderungen unterstützt.',
        links: [
          {
            link: 'https://www.umweltfoerderung.at/privatpersonen',
            linkText: 'Mehr zu Förderungen',
          },
        ],
      },
      {
        id: 2,
        icon: 'lightbulb-on',
        condition: answers => answers[7]?.param === 3, // Frage 8: Nicht bekannt
        title: 'Über Alter des Heizgerätes informieren',
        text: 'Das Alter des Heizgerätes hat einen großen Einfluss auf Heizungseffizienz. Um Ihre Heizungseffizienz zu optimieren, informieren Sie sich über das Alter des Heizgerätes.',
      },
    ],
  },
  {
    title: 'Wird das Heizgerät jährlich und fachkundig gewartet?',
    subtitle:
      'Wartung und Instandhaltung muss von einer Person mit den notwendigen Fachkenntnissen (laut Energiesparverordnung §11, Abs. 3) durchgeführt werden. Entlüftung von Heizkörpern zählt nicht zu dieser Wartung.',
    name: 'maintenance',
    id: 9,
    progressbarArea: 2,
    condition: answers =>
      answers.length > 5 && [2, 5, 6, 8].includes(answers[5]?.param),
    options: [
      {
        param: 1,
        text: 'Ja',
        points: 0,
      },
      {
        param: 2,
        text: 'Nein',
        points: 3,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'circle-check',
        condition: answers => answers[8]?.param === 1, // Frage 9: wird gewartet
        title: 'Wartung richtig gemacht',
        text: 'Durch regelmäßige Wartung Ihrer Heizung kümmern Sie sich bereits um eine lange Lebensdauer und eine optimale Funktionsweise Ihrer Heizungsanlage.',
        links: [
          {
            link: 'https://www.wienenergie.at/blog/thermenwartung-was-muss-das-muss/',
            linkText: 'Mehr zur Wartung Ihrer Therme',
          },
        ],
      },
      {
        id: 2,
        icon: 'lightbulb-on',
        condition: answers => answers[8]?.param === 2, // Frage 9: wird nicht gewartet
        title: 'Heizgerät regelmäßig warten',
        text: 'Die regelmäßige Wartung Ihrer Heizung ist entscheidend, um eine lange Lebensdauer und eine optimale Funktionsweise sicherzustellen. Beauftragen Sie deshalb eine fachkundige Person mit der jährlichen Inspektion Ihrer Heizungsanlage vor Beginn der Heizungsperiode.',
        links: [
          {
            link: 'https://www.wienenergie.at/blog/thermenwartung-was-muss-das-muss/',
            linkText: 'Mehr zur Wartung Ihrer Therme',
          },
        ],
      },
    ],
  },
  {
    title:
      'Wie hoch ist Ihre durchschnittliche Raumtemperatur während der Heizperiode?',
    name: 'temperature',
    id: 10,
    progressbarArea: 3,
    options: [
      {
        param: 1,
        text: 'Unter 18 Grad',
        points: 7,
      },
      {
        param: 2,
        text: '18-22 Grad',
        points: 0,
      },
      {
        param: 3,
        text: 'Über 22 Grad',
        points: 7,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers => answers[9]?.param === 1, // Frage 10: unter 18 Grad
        title: 'Temperatur optimieren',
        text: 'Auch wenn Sie eine niedrigere Raumtemperatur bevorzugen, achten Sie darauf, dass die Temperatur nicht allzu sehr sinkt. Sobald die Temperatur unter 12 °C sinkt dauert es sehr lange die Räume wieder auf eine angenehme Temperatur aufzuheizen.',
      },
      {
        id: 2,
        icon: 'circle-check',
        condition: answers => answers[9]?.param === 2, // Frage 10: 18-22 Grad
        title: 'Temperatur richtig gewählt',
        text: 'Auch wenn Sie eine niedrigere Raumtemperatur bevorzugen, achten Sie darauf, dass die Temperatur nicht allzu sehr sinkt. Sobald die Temperatur unter 12 °C sinkt, dauert es sehr lange, die Räume wieder auf eine angenehme Temperatur aufzuheizen.',
      },
      {
        id: 3,
        icon: 'lightbulb-on',
        condition: answers => answers[9]?.param === 3, // Frage 10: über 22 Grad
        title: 'Temperatur optimieren',
        text: 'Die empfohlene Raumtemperatur liegt zwischen 18 und 22 °C. Bereits 1 °C weniger Raumtemperatur bedeutet immerhin rund 6 % weniger Heizenergie.',
      },
      {
        id: 4,
        icon: 'lightbulb-on',
        condition: answers => answers[6]?.param !== 3, // Frage 5: nicht Fussbodenheizung
        title: 'Teppiche auslegen',
        text: 'Durch das Auslegen von Teppichen auf glatten Böden wird das Kälteempfinden verändert. Das warme Gefühl am Boden führt dazu, dass die Raumtemperatur bis zu zwei Grad wärmer empfunden wird. So kann die Heizung um zwei Grad niedriger eingestellt werden.',
      },
    ],
  },
  {
    title: 'Wie regeln Sie Ihre Raumtemperatur?',
    name: 'tempRegulation',
    id: 11,
    progressbarArea: 3,
    options: [
      {
        param: 1,
        text: 'Manuell',
        points: 3,
      },
      {
        param: 2,
        text: 'Raumthermostat',
        points: 0,
      },
      {
        param: 3,
        text: 'Thermostatventile (am Heizkörper)',
        points: 0,
      },
      {
        param: 4,
        text: 'Kombination: Raum- und Thermostatventile',
        points: 1,
      },
    ],
    infoBoxes: [
      {
        id: 1,
        title: 'Manuell',
        text: 'Bei der manuellen Temperaturregelung wird die Heizung direkt am Gerät durch den/die Benutzer*in eingestellt. Dies erfordert, dass man physisch die Temperatur ändert, wenn es zu warm oder zu kalt wird.',
        image: manuellImg,
        alt: '',
        icon: 'gauge-simple-low',
      },
      {
        id: 2,
        title: 'Raumthermostat',
        text: 'Ein Raumthermostat ist ein Gerät, das die Temperatur in einem Raum misst und die Heizung automatisch reguliert, um eine eingestellte Temperatur zu halten. Es sorgt für eine konstante und angenehme Raumtemperatur ohne manuelle Eingriffe.',
        image: raumthermostatImg,
        alt: '',
        icon: 'home',
      },
      {
        id: 3,
        title: 'Thermostatventile (am Heizkörper)',
        text: 'Thermostatventile am Heizkörper ermöglichen die Regelung der Heizleistung jedes einzelnen Heizkörpers. Sie messen die Raumtemperatur und passen die Heizwasserzufuhr an, um die gewünschte Temperatur zu erreichen und zu halten.',
        image: thermostatventilImg,
        alt: '',
        icon: 'gears',
      },
      {
        id: 4,
        title: 'Kombination: Raumthermostat und Thermostatventile',
        text: 'Thermostatventile am Heizkörper ermöglichen die Regelung der Heizleistung jedes einzelnen Heizkörpers. Sie messen die Raumtemperatur und passen die Heizwasserzufuhr an, um die gewünschte Temperatur zu erreichen und zu halten.',
        image: kombiImg,
        alt: '',
        icon: 'sliders-up',
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers =>
          answers[10]?.param === 1 && answers[6]?.param !== 4, // Frage 11: Manuell, Frage 7: NICHT Heizkörper
        title: 'Thermostat installieren',
        text: 'Eine moderne Heizung benötigt eine moderne Regelung. Diese senkt nicht nur den Energieverbrauch, sondern erhöht auch den Komfort.',
      },
      {
        id: 2,
        icon: 'lightbulb-on',
        condition: answers =>
          answers[10]?.param === 1 && answers[6]?.param === 4, // Frage 11: Manuell, Frage 7: Heizkörper
        title: 'Themostatventile installieren',
        text: 'Thermostatventile machen es möglich, die Temperaturen in den Räumen an den Bedarf anzupassen. Dadurch, dass sie dabei auch Fremdwärme durch Sonne, Elektrogeräte und Personen berücksichtigen, sind sie der beste Beweis dafür, dass sich Energiesparen und Komfortgewinn nicht ausschließen.',
      },
      {
        id: 3,
        icon: 'lightbulb-on',
        condition: answers => answers[10]?.param === 2, // Frage 11: Raumthermostat
        title: 'Raumthermostat optimal positionieren',
        text: 'Achten Sie darauf, dass Ihr Raumthermostat so montiert ist, dass nicht die Sonne darauf scheint oder es beeinflusst wird von anderen Wärmequellen wie zum Beispiel Elektrogeräte.',
      },
      {
        id: 4,
        icon: 'lightbulb-on',
        condition: answers => answers[10]?.param === 4, // Frage 11: Kombination
        title: 'Thermostatventil voll öffnen',
        text: 'In dem Zimmer, wo ein Raumthermostat installiert ist, soll kein Thermostatventil montiert werden. Falls Sie Zimmer haben, in denen beide Arten von Thermostaten vorhanden sind, achten Sie darauf, dass das Thermostatventil voll geöffnet ist.',
      },
    ],
  },
  {
    title: 'Wie lüften Sie meistens während der Heizsaison?',
    name: 'airing',
    id: 12,
    progressbarArea: 3,
    options: [
      {
        param: 1,
        text: 'Bedarfslüften',
        subtext:
          'Lüften erfolgt überwiegend nach Bedarf, um die Raumtemperatur zu regulieren oder die Luft in den Räumlichkeiten zu erfrischen.',
        points: 3,
      },
      {
        param: 2,
        text: 'Dauerlüften',
        subtext:
          'Gelüftet wird überwiegend, indem Fenster über einen längeren Zeitraum gekippt oder geöffnet werden.',
        points: 7,
      },
      {
        param: 3,
        text: 'Mit einer Lüftungsanlage',
        subtext:
          'Lüften erfolgt überwiegend mittels einer Lüftungsanlage, die einen Luftaustausch gewährleistet.',
        points: 0,
      },
      {
        param: 4,
        text: 'Stoß- bzw. Querlüften',
        subtext:
          'Lüften erfolgt überwiegend, in dem mehrere Fenster/Türen kurz gleichzeitig geöffnet werden, um einen Durchzug zu erzielen.',
        points: 0,
      },
      {
        param: 5,
        text: 'Gar nicht',
        points: 5,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers => [1, 5].includes(answers[11]?.param), // Frage 12: Bedarfslüften, Gar nicht
        title: 'Regelmäßig lüften',
        text: 'Lüften Sie ungefähr alle drei Stunden kräftig für wenige Minuten durch. Am besten stoßlüften Sie quer durch Öffnen von gegenüberliegenden Fenstern oder Türen. Richtiges Lüften bringt bessere Luftqualität und senkt auch die Heizkosten.',
        links: [
          {
            link: 'https://www.wienenergie.at/blog/richtig-lueften-so-gehts-frische-luft-und-energieeffizienz-im-einklang/',
            linkText: 'Weitere Lüftungstipps',
          },
        ],
      },
      {
        id: 2,
        icon: 'lightbulb-on',
        condition: answers => answers[11]?.param === 2, // Frage 12: Dauerlüften
        title: 'Dauerlüften vermeiden',
        text: 'Verzichten Sie auf ständig gekippte Fenster und lüften Sie ungefähr alle drei Stunden kräftig für wenige Minuten durch. Am besten stoßlüften Sie quer durch Öffnen von gegenüberliegenden Fenstern oder Türen. Richtiges Lüften bringt bessere Luftqualität und senkt auch die Heizkosten.',
        links: [
          {
            link: 'https://www.wienenergie.at/blog/richtig-lueften-so-gehts-frische-luft-und-energieeffizienz-im-einklang/',
            linkText: 'Weitere Lüftungstipps',
          },
        ],
      },
      {
        id: 3,
        icon: 'circle-check',
        condition: answers => answers[11]?.param === 3, // Frage 12: Lüftungsanlage
        title: 'Lüften richtig gemacht',
        text: 'Mit Ihrer Lüftungsanlage sorgen Sie bereits für einen regelmäßigen Luftaustausch, der auch Ihre Heizkosten senkt.',
      },
      {
        id: 4,
        icon: 'circle-check',
        condition: answers => answers[11]?.param === 4, // Frage 12: Stoß- bzw. Querlüften
        title: 'Lüften richtig gemacht',
        text: 'Durch Stoß- oder Querlüften sorgen Sie bereits für einen regelmäßigen Luftaustausch, der auch Ihre Heizkosten senkt.',
      },
    ],
  },
  {
    title: 'Wird ein zusätzliches Heizsystem genutzt?',
    subtitle:
      'Hinweis: Zu zusätzlichen Heizsystemen gehören elektrische Heizgeräte, Heizlüften, Infrarot, Kaminöfen oder Splitklimageräte.',
    name: 'additionalHeating',
    id: 13,
    progressbarArea: 4,
    options: [
      {
        param: 1,
        text: 'Ja',
        points: 0,
      },
      {
        param: 2,
        text: 'Nein',
        points: 0,
      },
    ],
    tipps: [
      {
        id: 1,
        icon: 'lightbulb-on',
        condition: answers => answers[12]?.param === 1, // zusätzliche Heizung
        title: 'Einsatz von zusätzlichen Heizsystemen optimieren',
        text: 'Zusätzliche Heizsysteme bieten die Möglichkeit, die Raumtemperatur punktuell zu steigern. Allerdings sind diese Systeme nicht dafür geeignet, den Wärmebedarf dauerhaft zu regulieren.',
      },
    ],
  },
];

const warmwasserTipp = [
  {
    id: 1,
    icon: 'lightbulb-on',
    title: 'Warmwasserverbrauch im Blick behalten',
    text: 'Ihre Warmwasseraufbereitung kann ggf. Einfluss auf Ihren Heizungsverbrauch haben. Lernen Sie mehr darüber in unserem Warmwasser Check.',
    links: [
      {
        link: 'https://www.wienenergie.at/privat/produkte/energiesparservice/warmwassercheck/',
        linkText: 'Warmwasser Check',
      },
    ],
  },
];

const progressbarAreas = [
  { label: 'Wohnen', id: 1 },
  { label: 'Heizen', id: 2 },
  { label: 'Verhalten', id: 3 },
  { label: 'Sonstiges', id: 4 },
];

const resultCases = [
  {
    tacho: tachoRed,
    min: 0,
    max: 20,
    trackingColor: 'rot',
    image: resultIllus1,
    text: 'Jeder Anfang ist schwer, auch beim effizienten Heizen. Genau zu wissen, wie man am effizientesten heizt, ist gar nicht so einfach. Zahlreiche Faktoren haben darauf Einfluss. Die gute Nachricht ist, dass Sie bereits den ersten Schritt gemacht haben. Erkunden Sie, wie Sie die nächste Heizungsperiode sparsam und umweltschonend angehen können.',
  },
  {
    tacho: tachoOrange,
    min: 21,
    max: 40,
    trackingColor: 'orange',
    image: resultIllus2,
    text: 'Die ersten Schritte sind immer am schwierigsten und die haben Sie bereits hinter sich. Genau zu wissen, wie man am effizientesten heizt, ist gar nicht so einfach. Zahlreiche Faktoren haben darauf Einfluss. Erkunden Sie, wie Sie die nächste Heizungsperiode sparsam und umweltschonend angehen können, indem Sie Ihren Verbrauch optimieren.',
  },
  {
    tacho: tachoYellow,
    min: 41,
    max: 60,
    trackingColor: 'gelb',
    image: resultIllus3,
    text: 'Schau, schau, da hält wer mit! Sie machen bereits einiges richtig. Erkunden Sie, wie Sie die nächste Heizungsperiode sparsamer und umweltschonender angehen können und was Sie bereits gut machen.',
  },
  {
    tacho: tachoLightGreen,
    min: 61,
    max: 80,
    trackingColor: 'hellgruen',
    image: resultIllus4,
    text: 'Hut ab! Heizungseffizienz ist nichts Neues für Sie! Sie machen bereits vieles richtig! Erkunden Sie, wie Sie die nächste Heizungsperiode noch sparsamer und umweltschonender angehen können und was alles Sie gut machen. Sind Sie bereit für das nächste Level?',
  },
  {
    tacho: tachoGreen,
    min: 81,
    max: 100,
    trackingColor: 'dunkelgruen',
    image: resultIllus5,
    text: 'Alle Achtung! Da ist ein*e Heizungsexpert*in am Start! Sie sind bestens zum Thema Heizen ausgestattet und informiert. Inspirieren Sie andere mit Ihrer Expertise, indem Sie unseren Heizungscheck teilen. Erkunden Sie, was Sie bereits alles richtig machen und entdecken Sie, wo sich möglicherweise noch Heizungspotenzial verbirgt.',
  },
];

export { progressbarAreas, questions, resultCases, warmwasserTipp };
